import Vue from "vue";
import VueRouter from "vue-router";
import MyHome from "../views/MyHome";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: MyHome,
  },
  {
    path: "/about",
    name: "About Us",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/MyAbout.vue"),
  },
  //   {
  //     path: "/about",
  //     name: "About Us",
  //     component: () =>
  //       import(/* webpackChunkName: "about" */ "../views/AboutUs.vue"),
  //   },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
      //Or for Vue 3:
      //return {el: to.hash}
    } else {
      return { x: 0, y: 0 };
    }
  },
});
export default router;
